import { render, staticRenderFns } from "./ScreenTodoList.vue?vue&type=template&id=3f8bc16a&scoped=true"
import script from "./ScreenTodoList.vue?vue&type=script&lang=js"
export * from "./ScreenTodoList.vue?vue&type=script&lang=js"
import style0 from "./ScreenTodoList.vue?vue&type=style&index=0&id=3f8bc16a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8bc16a",
  null
  
)

export default component.exports